import { render, staticRenderFns } from "./BackofficeNavManagement.vue?vue&type=template&id=c1565198&scoped=true&"
import script from "./BackofficeNavManagement.vue?vue&type=script&lang=js&"
export * from "./BackofficeNavManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1565198",
  null
  
)

export default component.exports